import { FieldSchema } from "../../../Schema";
import { isSecondaryIdField, LinkedInstance } from "../../common/external-sources/LinkedInstances";
import { User } from "../../common/external-sources/Users";
import { EntryTypes } from "../../common/fields";
import { Modes } from "../../common/fields/mode";
import { readStoredText, writeStoredText } from "../../common/fields/stored";

export const serialNumber: FieldSchema = {
  grid: {
    label: "Serial number",
    displayed: true,
    order: 2,
    defaultVisible: true,
    filterBlank: true,
  },
  name: "serialNumber",
  // Declared for both inbound directions: the rule belongs to the attribute, not to
  // whether the record arrived from AppSync or from a DynamoDB read.
  dataTransform: {
    fromGraphql: { getter: ({ serialNumber }) => readStoredText(serialNumber) },
    fromDb: { getter: ({ serialNumber }) => readStoredText(serialNumber) },
    // Back out as the placeholder: this column is one an index is keyed on, or
    // one the resolvers keep a placeholder in for a consumer's index.
    toDb: { getter: ({ serialNumber }) => writeStoredText(serialNumber) },
  },
  display: {
    displayed: true,
  },
  validation: {
    // See `equipmentId`: the mapping is the master data's own answer, and the "None" test is
    // the fallback for an instance that declares none.
    required: {
      getter: ({ linkedInstance }) =>
        isSecondaryIdField(linkedInstance, "serialNumber") ??
        (linkedInstance as LinkedInstance)?.linkedInstance === "None",
      fields: ["linkedInstance"],
    },
  },
  form: {
    label: "Serial number",
    disabled: {
      getter: ({ entryType, linkedInstance, mode, currentUser }) => {
        const linkedInstanceValue = (linkedInstance as LinkedInstance)?.linkedInstance;
        return (
          [EntryTypes.STANDALONE_EQUIPMENT, EntryTypes.CLUSTER_SUBEQUIPMENT].includes(entryType as EntryTypes) &&
          [Modes.EDIT, Modes.BULK_EDIT].includes(mode as Modes) &&
          (
            (
              ["P1S Uni-Directional"].includes(linkedInstanceValue) &&
              !(currentUser as User)?.isAdmin
            )
          )
        );
      },
      fields: ["entryType", "linkedInstance", "mode", "currentUser"],
    },
  },
};
